import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getSidebarData(params) {
  return request({
    url: '/GetSidebarData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 60000001,
      MessageID: btcguid(),
      Data: {
      }
    }
  })
}

export function updateSidebarData(params) {
  console.log(JSON.stringify(params))
  return request({
    url: '/UpdateSidebarData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 60000002,
      MessageID: btcguid(),
      Data: {
        StorageID: params.StorageID,
        Key: params.Key,
        StringValue: params.StringValue
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/newdata.js